import { useTranslation } from 'react-i18next';
import { useRecapTranslationsQuery } from '../../../services/HistoryPageServices';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';
import { initialGoDown, whileInView, transition } from "../../../helpers/animations";
import { Container } from 'react-bootstrap';
import { sanitizeCmsHtml } from '../../../helpers/sanitizeCmsHtml';

function HistoryBanner() {
  const { t } = useTranslation('recap_banner');

  const { data: recapTranslations, isLoading } = useRecapTranslationsQuery();

  if (!recapTranslations || isLoading) return null;

  return (
    <section className='history-banner'>
      <Container className='history-banner__container'>
        <motion.img
          initial={initialGoDown}
          whileInView={whileInView}
          viewport={{
            once: true,
            amount: 0.2
          }}
          transition={transition}
          className='history-banner__img'
          src={t('cover_image')}
          loading="eager"
          decoding="async"
          fetchPriority="high"
          alt={t('cover_image_alt_text')}
        />
        <motion.div
          initial={initialGoDown}
          whileInView={whileInView}
          viewport={{
            once: true,
            amount: 0.2
          }}
          transition={transition}
          className='history-banner__card'
        >
          <div className='history-banner__heading'>{t('cover_section_name')}</div>
          <div className='history-banner__title'>{t('cover_title')}</div>
          <div>{parse(sanitizeCmsHtml(t('cover_description')))}</div>
        </motion.div>
      </Container>
    </section>
  );
}

export default HistoryBanner;